export enum SupportSubject {
    ACCOUNT = 'Account',
    WEBSITE_FUNCTIONALITY = 'Website Functionality',
    REFUNDS = 'Refunds',
    REACTIVATE_SUBSCRIPTION = 'Reactivate Subscription',
    OTHER = 'Other',
}

export interface SupportForm {
    email: string
    name: string
    subject: SupportSubject
    otherSubject: string
    body: string
}
